import { create } from 'zustand';

interface CheckoutStore {
  seatQuantity: number;
  setSeatQuantity: (seatQuantity: number) => void;
}

export const useCheckoutStore = create<CheckoutStore>(set => ({
  seatQuantity: 0, //this value represents additional seats, we include a minimum of 1 when we call the update account service
  setSeatQuantity: (seatQuantity: number) => set({ seatQuantity }),
}));
